export default __webpack_public_path__ + "static/media/readmegen.c44684fd.png";